import { correctNodes as W } from "./utils/correctFocus.js";
import { pickFocusable as s } from "./utils/firstFocus.js";
import { isGuard as _ } from "./utils/is.js";
var M = "NEW_FOCUS",
  j = function (u, x, d, r, n) {
    var e = u.length,
      g = u[0],
      C = u[e - 1],
      O = _(r);
    if (!(r && u.indexOf(r) >= 0)) {
      var i = r !== void 0 ? d.indexOf(r) : -1,
        D = n ? d.indexOf(n) : i,
        f = n ? u.indexOf(n) : -1;
      if (i === -1) return f !== -1 ? f : M;
      if (f === -1) return M;
      var a = i - D,
        I = d.indexOf(g),
        c = d.indexOf(C),
        t = W(d),
        F = r !== void 0 ? t.indexOf(r) : -1,
        G = n ? t.indexOf(n) : F,
        b = t.filter(function (U) {
          return U.tabIndex >= 0;
        }),
        v = r !== void 0 ? b.indexOf(r) : -1,
        h = n ? b.indexOf(n) : v,
        S = v >= 0 && h >= 0 ?
        // old/new are tabbables, measure distance in tabbable space
        h - v :
        // or else measure in focusable space
        G - F;
      if (!a && f >= 0 || x.length === 0) return f;
      var o = s(u, x[0]),
        p = s(u, x[x.length - 1]);
      if (i <= I && O && Math.abs(a) > 1) return p;
      if (i >= c && O && Math.abs(a) > 1) return o;
      if (a && Math.abs(S) > 1) return f;
      if (i <= I) return p;
      if (i > c) return o;
      if (a) return Math.abs(a) > 1 ? f : (e + f + a) % e;
    }
  };
export { M as NEW_FOCUS, j as newFocus };